var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardContent, CardHeader, Table, TableBody, TableCell, TableHead, TableRow, Typography, } from "@mui/material";
import { useMemo } from "react";
import { TeamColorBox } from "../teams/TeamColorBox";
export var LeagueTable = function (_a) {
    var matches = _a.matches;
    var leagueTable = useMemo(function () {
        var e_1, _a;
        var table = new Map();
        var ensureTeam = function (team) {
            if ((team === null || team === void 0 ? void 0 : team.id) && !table.has(team.id)) {
                table.set(team.id, {
                    team: team,
                    played: 0,
                    wins: 0,
                    draws: 0,
                    losses: 0,
                    goalsFor: 0,
                    goalsAgainst: 0,
                    goalDifference: 0,
                    points: 0,
                });
            }
        };
        var updateTeam = function (team, gf, ga, result) {
            var id = team.id;
            if (!table.has(id)) {
                table.set(id, {
                    team: team,
                    played: 0,
                    wins: 0,
                    draws: 0,
                    losses: 0,
                    goalsFor: 0,
                    goalsAgainst: 0,
                    goalDifference: 0,
                    points: 0,
                });
            }
            var entry = table.get(id);
            entry.played += 1;
            entry.goalsFor += gf;
            entry.goalsAgainst += ga;
            entry.goalDifference = entry.goalsFor - entry.goalsAgainst;
            if (result === "win") {
                entry.wins += 1;
                entry.points += 3;
            }
            else if (result === "draw") {
                entry.draws += 1;
                entry.points += 1;
            }
            else {
                entry.losses += 1;
            }
        };
        try {
            for (var matches_1 = __values(matches), matches_1_1 = matches_1.next(); !matches_1_1.done; matches_1_1 = matches_1.next()) {
                var match = matches_1_1.value;
                var result = match.intraSquadTournamentMatchResult;
                var teamA = match.teamA;
                var teamB = match.teamB;
                if (!teamA || !teamB)
                    continue;
                ensureTeam(teamA);
                ensureTeam(teamB);
                if (!result)
                    continue;
                var teamAScore = result.teamAScore, teamBScore = result.teamBScore;
                if (teamAScore > teamBScore) {
                    updateTeam(teamA, teamAScore, teamBScore, "win");
                    updateTeam(teamB, teamBScore, teamAScore, "loss");
                }
                else if (teamAScore < teamBScore) {
                    updateTeam(teamA, teamAScore, teamBScore, "loss");
                    updateTeam(teamB, teamBScore, teamAScore, "win");
                }
                else {
                    updateTeam(teamA, teamAScore, teamBScore, "draw");
                    updateTeam(teamB, teamBScore, teamAScore, "draw");
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (matches_1_1 && !matches_1_1.done && (_a = matches_1.return)) _a.call(matches_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return Array.from(table.values()).sort(function (a, b) {
            return b.points - a.points ||
                b.goalDifference - a.goalDifference ||
                b.goalsFor - a.goalsFor ||
                a.team.name.localeCompare(b.team.name);
        });
    }, [matches]);
    return (_jsx(Card, { elevation: 3, sx: { mb: 4 }, children: _jsxs(CardContent, { children: [_jsx(CardHeader, { title: "League Table" }), _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: "Team" }), _jsx(TableCell, { align: "right", children: "P" }), _jsx(TableCell, { align: "right", children: "W" }), _jsx(TableCell, { align: "right", children: "D" }), _jsx(TableCell, { align: "right", children: "L" }), _jsx(TableCell, { align: "right", children: "GF" }), _jsx(TableCell, { align: "right", children: "GA" }), _jsx(TableCell, { align: "right", children: "GD" }), _jsx(TableCell, { align: "right", children: "Pts" })] }) }), _jsx(TableBody, { children: leagueTable.map(function (teamStat) { return (_jsxs(TableRow, { children: [_jsx(TableCell, { children: _jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [_jsx(TeamColorBox, { color: teamStat.team.primaryColour, onClick: function () { } }), _jsx(Typography, { component: "span", variant: "body2", children: teamStat.team.name })] }) }), _jsx(TableCell, { align: "right", children: teamStat.played }), _jsx(TableCell, { align: "right", children: teamStat.wins }), _jsx(TableCell, { align: "right", children: teamStat.draws }), _jsx(TableCell, { align: "right", children: teamStat.losses }), _jsx(TableCell, { align: "right", children: teamStat.goalsFor }), _jsx(TableCell, { align: "right", children: teamStat.goalsAgainst }), _jsx(TableCell, { align: "right", children: teamStat.goalDifference }), _jsx(TableCell, { align: "right", children: teamStat.points })] }, teamStat.team.id)); }) })] })] }) }));
};
